import Project from '@/components/Project/Project.vue';
import ProjectCreate from '@/components/Project/Create/ProjectCreate.vue';
import Shortlist from '@/components/Project/Shortlist/Shortlist.vue';
import OrderView from '@/components/Project/Order/OrderView.vue';

export default [
    {
        name: 'project-create',
        path: '/project-create',
        component: ProjectCreate,
        meta: { roles: ['role_administrator'] },
    },
    {
        name: 'project-detail',
        path: '/project-:project_id',
        component: Project,
        meta: { roles: ['role_administrator'], widerHeader: true, menuSection: 'admin' },
        children: [
            {
                name: 'project-shortlist',
                path: '/project-:project_id-shortlist',
                component: Shortlist,
                meta: { roles: ['role_administrator'], widerHeader: true, menuSection: 'admin' },
            },
            {
                name: 'project-order',
                path: '/project-:project_id-order',
                component: OrderView,
                meta: { order: true, roles: ['role_administrator'], widerHeader: true, menuSection: 'admin' },
            },
        ],
    },
];
